import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef, Input, OnChanges,
  OnDestroy,
  OnInit,
  Output, SimpleChanges, ViewChild
} from '@angular/core';

import {EventEmitter} from "@angular/core";
import {
  DataGridColumnDef,
  SimpleDataGridColumnDef,
  SimpleDataGridColumnDefGroup
} from "../../models/data-grid-column-def.model";
import {CommonUtils} from "../../utils/common";
import {DataGridActionButtonDef} from "../../models/data-grid-action-button-def.model";
import {User} from "../../models/user.model";
import {Platform, PopoverController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "../../providers/user.service";
import {AppStateService} from "../../providers/app-state.service";
import {BehaviorSubject, Subscription} from "rxjs";
import {environment} from "../../../environments/environment";
import {DataGridActionButtonsMenuComponent} from "./data-grid-action-buttons-menu/data-grid-action-buttons-menu.component";
import {TranslatedPage} from "../../pages/translated.page";
import {DataGridEnumColumnItem} from "../../models/data-grid-enum-column-item.model";
@Component({
  selector: ' app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class DataGridComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild('dataRowDiv') dataRowDiv;
  @Input() dataValues: Object[];
  @Input() pageSize: number = environment.DEFAULT_RESULTS_LIMIT;
  @Input() valuesToSearch: string[];
  @Input() total: number;
  @Input() vetcode: string;

  @Input() fieldsToBlockCopy: string[] = [];

  @Input() disabledActionButtonsInfo: string;

  @Input() modelName: string;
  @Input() defaultSortOrder: string;
  @Input() defaultOrderBy: string;
  @Input() columnDef: Map<string, DataGridColumnDef> | Map<string, SimpleDataGridColumnDef> | Map<string, SimpleDataGridColumnDefGroup>;
  @Input() actionButtonsDef: DataGridActionButtonDef[];
  @Input() highlightedUUID: string;

  user: User;
  userSub: Subscription;

  isBusy: boolean;
  isBusySub: Subscription;

  dataTypes: Array<Map<string, Object>> = new Array<Map<string, Object>>();

  sortOrder: string = 'desc';
  orderBy: string;
  orderByUrl: string;

  showDeletedObjects: boolean = false;

  pages: number;
  pagesRange: number[] = [];

  @Output() pageSizeRequest = new EventEmitter<number>();
  @Output() changePage = new EventEmitter<number>();
  @Output() sortBy = new EventEmitter<string>();
  @Output() searchFieldsData = new EventEmitter<Map<string, string>>(true);
  @Output() editObj = new EventEmitter<string>();

  currentSearchColumn: string;

  searchFieldsDataMap: Map<string, string> = new Map();
  searchFieldsDataMapValues: Map<string, string> = new Map();

  dataStructure: string[];
  loadingData: boolean;
  pageNumber: number;
  textForPageNumber: string = "numer strony :";
  searchFor: string = "Szukaj: ";
  textForPageSize: string = 'Ilość elementów: ';

  prevPageLoading: boolean = false;
  nextPageLoading: boolean = false;
  private initializeTranslation: boolean = true;
  language: string;
  responsiveMode: boolean = false;
  private mouseHoldTimer: any;
  highlightedColumn: string = null;
  private sortBlocked: boolean = false;
  private pageRangeDelta: number = 2;

  constructor(
    public common: CommonUtils,
    private popoverController: PopoverController,
    private translateServiceLib: TranslateService,
    private elementRef: ElementRef,
    private userService: UserService,
    private appStateService: AppStateService,
    private platform: Platform
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.modelName === 'Article') {
      if (changes.highlightedUUID) {
        this.highlightedUUID = changes.highlightedUUID.currentValue;
        if(this.highlightedUUID && this.dataTypes) {
          this.dataTypes.forEach((e) => {
            if (e.get('uuid') === this.highlightedUUID) {
              e.set('highlighted', true);
            } else {
              e.set('highlighted', false);
            }
          });
        }
      }
      if (changes.dataValues && changes.dataValues.previousValue) {
        this.dataTypes = new Array<Map<string, Object>>();
        this.prepareDataTypes();
      }
    }
    }

  ngOnInit() {
    this.appStateService.dataGridLoadDataSubject.subscribe(load => {
      this.loadingData = load;
    })
    this._initTranslate();

    this.userSub = this.userService.getUser().subscribe(user => {
      if (user) {
        this.user = this.common.bestTypedCopyEver<User>(new User(), user);
      }
    });
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    if (this.vetcode) {
      this.searchFieldsDataMapValues.set("vetcodeId", this.vetcode)
      this.searchFieldsDataMap.set("vetcodeId", this.vetcode)
    }


    this.prepareDataStructure();
    this.prepareDataTypes();

    if (this.total && this.dataValues) {
      this.pages = Math.ceil(this.total / this.pageSize);
      this.pageNumber = 1;
      this.preparePagesRange();

    }

    if (this.platform.isLandscape()) {
      this.responsiveMode = false;
    } else {
      this.responsiveMode = true;
    }

    if (this.defaultSortOrder) this.sortOrder = this.defaultSortOrder;
  }

  private prepareDataStructure() {
    const object = this.dataValues[0];
    if (object) {
      this.dataStructure = [];

      if (this.columnDef) {
        this.columnDef.forEach((cDef, columnKey) => {
          if (this.user) {
            if (this.user.isClient()) {     // todo PYTANIE , dahsboard jest jeden i czy tuaj też będzie coś w rodzaju klienta? raczej nie
              if (cDef.forClient) {
                this.dataStructure.push(columnKey);
              }
            } else {
              this.dataStructure.push(columnKey);
            }
          } else {
            this.dataStructure.push(columnKey);
          }
        });
      } else {
        this.dataStructure = Object.keys(object);
      }
    } else {
      this.dataStructure = [];

      if (this.columnDef) {
        this.columnDef.forEach((cDef, columnKey) => {
          if (this.user) {
            if (this.user.isClient()) {     // todo PYTANIE , dahsboard jest jeden i czy tuaj też będzie coś w rodzaju klienta? raczej nie
              if (cDef.forClient) {
                this.dataStructure.push(columnKey);
              }
            } else {
              this.dataStructure.push(columnKey);
            }
          } else {
            this.dataStructure.push(columnKey);
          }
        });
      }
    }
  }

  onChangePageSize(value: number) {
    this.pageSize = value;
    this.pageSizeRequest.emit(this.pageSize);
  }

  onNextPage() {
    this.pageNumber = this.pageNumber + 1
    this.nextPageLoading = true;
    this.preparePagesRange();
    this.changePage.emit(this.pageNumber);
  }

  onPreviousPage() {
    this.pageNumber = this.pageNumber - 1
    this.prevPageLoading = true;
    this.preparePagesRange();
    this.changePage.emit(this.pageNumber);
  }

  private prepareDataTypes() {
    this.dataTypes.push(new Map<string, Object>());
    this.dataValues.forEach(obj => {
      let map = new Map<string, Object>();
      for (let [k, v] of Object.entries(obj)) {
        map.set(k, v);
      }
      this.dataTypes.push(map);
      if(this.modelName === 'Article' && this.highlightedUUID) {
        this.dataTypes.forEach((e) => {
          if (e.get('uuid') === this.highlightedUUID) {
            e.set('highlighted', true);
          } else {
            e.set('highlighted', false);
          }
        });
      }
    });

    if (this.currentSearchColumn) {
      setTimeout(() => {
        const el = this.elementRef.nativeElement.querySelector(`#${this.currentSearchColumn}_sf`);
        if (this?.getColumnDef(this.currentSearchColumn)?.searchFieldType === 'enum') {
          (el as HTMLIonSelectElement).focus();
        } else {
          (el as HTMLIonSearchbarElement)?.setFocus().then(() => {
            console.log('focus')
          });
        }
      }, 200);
    }
  }

  onAddToMap(columnDef: DataGridColumnDef | SimpleDataGridColumnDef | SimpleDataGridColumnDefGroup, ev: any) {
    console.log("KEY EVENT");
    console.log(ev);
    const search = ev?.target?.value;

    if (columnDef.columnKeyFullPath) {
      this.currentSearchColumn = columnDef.columnKeyFullPath;
    } else {
      this.currentSearchColumn = columnDef.columnKey;
    }

    let columnKeys: string[] = [];

    if (columnDef instanceof SimpleDataGridColumnDefGroup && columnDef.columnKeys) {
      const searchSplit: string[] = search.split(' ');
      if (columnDef.adaptiveSearch && searchSplit.length === columnDef.columnKeys.length) {
        for (let keyIndex = 0; keyIndex < searchSplit.length; keyIndex++) {
          if (searchSplit[keyIndex]) {
            this.searchFieldsDataMap.delete(`${columnDef.columnKeys[keyIndex]}#CMPLX#${this.currentSearchColumn}`);
            this.searchFieldsDataMapValues.delete(`${columnDef.columnKeys[keyIndex]}#CMPLX#${this.currentSearchColumn}`);
            this.searchFieldsDataMap.set(columnDef.columnKeys[keyIndex], searchSplit[keyIndex]);
            this.searchFieldsDataMapValues.set(columnDef.columnKeys[keyIndex], searchSplit[keyIndex]);
          }
        }
      } else {
        columnDef.columnKeys.forEach(ck => {
          this.searchFieldsDataMap.delete(ck);
          this.searchFieldsDataMapValues.delete(ck);
          columnKeys.push(`${ck}#CMPLX#${this.currentSearchColumn}`)
        })
      }
    }
    columnKeys.push(columnDef.columnKey);

    for (const columnKey of columnKeys) {
      if (columnDef.searchFieldType === 'string' || columnDef.searchFieldType === 'object' || columnDef.searchFieldType === 'enum') {

        if (search === '' || search === undefined) {
          this.searchFieldsDataMap.delete(columnKey);
          this.searchFieldsDataMapValues.delete(columnKey);
        } else {
          if (columnDef.searchFieldType === 'string' || columnDef.searchFieldType === 'enum') {
            this.searchFieldsDataMap.set(columnKey, search);
            this.searchFieldsDataMapValues.set(columnKey, search);
          } else {
            if (search.length >= 2) {
              this.searchFieldsDataMap.set(columnKey, search);
              this.searchFieldsDataMapValues.set(columnKey, search);
            } else if (search.length < 3) {
              this.searchFieldsDataMap.delete(columnKey);
              this.searchFieldsDataMapValues.set(columnKey, search);
            }
          }
        }
      } else if (columnDef.searchFieldType === 'numberInterval') {
        let min, max;

        if (search.indexOf('-') > 0) {
          min = search.split('-')[0].trim();
          max = search.split('-')[1].trim();
        } else {
          min = search.split('-')[0].trim();
          max = search.split('-')[0].trim();
        }

        if (search === '' || search === '0') {
          this.searchFieldsDataMap.delete(`${columnKey}__min`);
          this.searchFieldsDataMapValues.delete(`${columnKey}___min`);
          this.searchFieldsDataMap.delete(`${columnKey}__max`);
          this.searchFieldsDataMapValues.delete(`${columnKey}__max`);
        } else {
          this.searchFieldsDataMap.set(`${columnKey}__min`, min);
          this.searchFieldsDataMap.set(`${columnKey}__max`, max);
        }

      }
    }
  }

  onSearch() {
    this.searchFieldsData.emit(this.searchFieldsDataMap);
  }

  onSearchEnum(columnDef: DataGridColumnDef | SimpleDataGridColumnDef | SimpleDataGridColumnDefGroup, ev: any, numberIntervalType: string = undefined) {
    this.onAddToMap(columnDef, ev);
    this.onSearch();
  }

  onSort(column: string) {
    // sort blocked with highlight interaction
    if(this.sortBlocked) {
      this.sortBlocked = false;
      return;
    }
    if (this.sortOrder === 'ASC') {
      this.sortOrder = 'DESC';
    } else {
      this.sortOrder = 'ASC';
    }

    const cdef = this.getColumnDef(column);

    if (cdef instanceof SimpleDataGridColumnDefGroup) {
      if (cdef.columnKeys) {
        this.orderByUrl = cdef.columnKeys.join(',');
      }
    } else {
      this.orderByUrl = null;
    }

    this.orderBy = column;

    this.sortBy.emit(column.concat(',', this.sortOrder));
  }

  refresh(dataValues: Object[]) {
    this.dataTypes = new Array<Map<string, Object>>();
    this.dataValues = dataValues;

    if (this.prevPageLoading) this.prevPageLoading = false;
    if (this.nextPageLoading) this.nextPageLoading = false;
    this.appStateService.updateDataGridLoadSubject(false);
    this.loadingData = false;

    if (this.total && this.dataValues) {
      this.pages = Math.ceil(this.total / this.pageSize);
      this.pageNumber = this.pageNumber <= this.pages ? this.pageNumber : 1;
      this.preparePagesRange();
    }
    // this.prepareDataStructure();
    this.prepareDataTypes();
  }

  onChangePage(newPageNumber: any) {
    this.pageNumber = newPageNumber;
    this.preparePagesRange()
    this.changePage.emit(newPageNumber);
  }

  onOpenEditForm(map: Map<string, Object>) {
    if (!this.loadingData && !this.actionButtonsDef) {
      this.editObj.emit(map.get('uuid') as string);
    }
  }

  getOrderBy() {
    if (this.orderByUrl) {
      return (this.orderByUrl ? this.orderByUrl : this.defaultOrderBy)
    } else {
      return (this.orderBy ? this.orderBy : this.defaultOrderBy)
    }
  }

  getSortOrder() {
    return (this.sortOrder ? this.sortOrder : this.defaultSortOrder)
  }

  getColumnLabelOrKey(column: string) {
    if (this.columnDef && this.columnDef.has(column)) {
      if (this.columnDef instanceof DataGridColumnDef) {
        return (this.columnDef.get(column) as DataGridColumnDef)?.columnLabel
      } else {
        return this.common.getModelFieldNameTKey(this.modelName, column);
      }
    } else {
      return column;
    }
  }

  getColumnDef(column: string) {
    if (this.columnDef && this.columnDef.has(column)) {
      return this.columnDef.get(column);
    } else {
      return new DataGridColumnDef(false, false, column, column, 'string');
    }
  }

  getDataCssClass(data: Map<string, Object>) {
    if (this.loadingData) {
      return 'disabled-text';
    } else {
      if (data && data.get('deleted') !== undefined && data.get('deleted') !== null) {
        return 'deleted-object';
      } else {
        return '';
      }
    }
  }

  getStyle(data: Map<string, Object>) {
    if (this.modelName !== 'Article') {
      return 'padding-left:5px;';
    } else {
      const style = 'padding-left: 5px;';
      return data.get('highlighted') === true ? style.concat('color:#049491') : style;
    }
  }

  onSearchToggle(column: string, isChecked: boolean) {
    if (isChecked) {
      this.searchFieldsDataMap.set(column, 'true');
    } else {
      this.searchFieldsDataMap.delete(column);
    }
    this.searchFieldsData.emit(this.searchFieldsDataMap);
  }

  getToggleSearchFieldValue(column: string): boolean {
    if (this.searchFieldsDataMap.has(column)) {
      return this.searchFieldsDataMap.get(column) === 'true';
    } else {
      return false;
    }
  }

  async openActionButtonsMenu(ev: any, data: any) {
    if (this.actionButtonsDef && this.actionButtonsDef.length > 1) {
      const popover = await this.popoverController.create({
        component: DataGridActionButtonsMenuComponent,
        componentProps: {
          'actionButtonsDef': this.actionButtonsDef,
          'data': data
        },
        event: ev,
        translucent: true
      });
      await popover.present();

      const {role} = await popover.onDidDismiss();
    }
  }

  sortIconVisible(column: string) {
    return this.orderBy === column;
  }

  sortIcon() {
    if (this.sortBy) {
      if (this.sortOrder === 'DESC') return 'arrow-up-outline';
      else if (this.sortOrder === 'ASC') return 'arrow-down-outline';
    }
  }

  _translateLanguage(): void {
    this.translateServiceLib.use(this.language);
  }

  translationExist(key: string): boolean {
    return this.translateServiceLib.instant(key) !== key;
  }

  _initTranslate() {
    console.log('_initTranslate');
    if (this.initializeTranslation && !TranslatedPage.translationInInitialized) {
      // Set the default language for translation strings, and the current language.
      this.translateServiceLib.setDefaultLang('pl');
      this.language = 'pl';

      if (this.translateServiceLib.getBrowserLang() !== undefined && this.language !== this.translateServiceLib.getBrowserLang()) {
        this.translateServiceLib.setDefaultLang('pl');
        this.language = 'pl';
      } else {
        this.language = 'pl';
      }

      this._translateLanguage();
    }
  }

  toggleShowDeletedObjects(checked: boolean) {
    this.showDeletedObjects = checked;
    this.searchFieldsData.emit(this.searchFieldsDataMap);
  }

  getHeaderClass(colum: any) {
    if (this.sortIconVisible(colum)) {
      return 'data_row_header current_search_col'
    } else {
      return 'data_row_header';
    }
  }

  clearSearchField(column: string, searchFieldType: string = null) {
    if ((this.getColumnDef(column) as SimpleDataGridColumnDefGroup).columnKeys) {
      let adaptiveSearch = (this.getColumnDef(column) as SimpleDataGridColumnDefGroup)?.adaptiveSearch;
      (this.getColumnDef(column) as SimpleDataGridColumnDefGroup).columnKeys
        .forEach(e => {
          if (adaptiveSearch) {
            this.searchFieldsDataMapValues.delete(e);
            this.searchFieldsDataMap.delete(e);
          }
          this.searchFieldsDataMapValues.delete(`${e}#CMPLX#${column}`);
          this.searchFieldsDataMap.delete(`${e}#CMPLX#${column}`);
        })
    }

    if (searchFieldType && searchFieldType == 'numberInterval') {
      this.searchFieldsDataMapValues.delete(column+'__min');
      this.searchFieldsDataMap.delete(column+'__min');
      this.searchFieldsDataMapValues.delete(column+'__max');
      this.searchFieldsDataMap.delete(column+'__max');
    } else {
      this.searchFieldsDataMapValues.delete(column);
      this.searchFieldsDataMap.delete(column);
    }

    this.searchFieldsData.emit(this.searchFieldsDataMap);
  }

  getDataCellValue(data: Map<string, Object>, columnKey: string) {
    if (data.has(columnKey)) return data.get(columnKey);
    else {
      return '-';
    }
  }

  isEnumComplex(obj: any) {
    if (obj instanceof DataGridEnumColumnItem) {
      return true;
    } else {
      return false;
    }
  }

  onModeChange(checked: boolean) {
    this.responsiveMode = checked
  }

  onResize(event) {
    if (this.platform.isLandscape()) {
      this.responsiveMode = false;
    } else {
      this.responsiveMode = true;
    }
  }

  ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
    if (this.mouseHoldTimer) {
      clearTimeout(this.mouseHoldTimer);
    }
  }

  actionButtonsDefsAreEnabled(data: Map<string, Object>): boolean {
    return this.actionButtonsDef.filter(e => {
      return e.isEnabled(data);
    }).filter(a => {
      return !(data.get('deleted') && !a.enabledForDeletedObjects);
    }).length > 0
  }

  showDisabledActionButtonsInfo() {
    if (this.disabledActionButtonsInfo) {
      this.common.presentInfoToast(this.disabledActionButtonsInfo);
    }
  }


  copyValue(val: any, columnKey: string){
    console.log(columnKey)
    if (!this.fieldsToBlockCopy || !
      this.fieldsToBlockCopy.includes(columnKey)) {
      if (val) {
        val = val?.toString().replaceAll('<p>', '').replaceAll('<AUTO>', '-').replaceAll('<strong>', '').replaceAll('</p>', ' ').replaceAll('</strong>', ' ');
      }

      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.addEventListener('copy', (e: ClipboardEvent) => {
        e.clipboardData.setData('text/plain', (val));
        e.preventDefault();
        document.removeEventListener('copy', null);
      });

      document.execCommand('copy');
      document.body.removeChild(selBox);

      this.common.presentSimpleInfoToast(`Wartość '${val}' skopiowana do schowka`, 'bottom', 2000);
    }
  }

  onMouseDown(event: MouseEvent, column) {
    this.mouseHoldTimer = setTimeout(() => {
      if (this.highlightedColumn !== column) {
        this.highlightedColumn = column;
      } else {
        this.highlightedColumn = null;
      }
      this.sortBlocked = true;
    }, 300);
  }

  onMouseLeave(event: MouseEvent) {
    clearTimeout(this.mouseHoldTimer);
  }

  onMouseUp(event: MouseEvent) {
    clearTimeout(this.mouseHoldTimer);
  }

  isHighlighted(columnDef: DataGridColumnDef | SimpleDataGridColumnDef | SimpleDataGridColumnDefGroup) {
    return columnDef.columnKey === this.highlightedColumn;
  }

  private preparePagesRange() {
    this.pagesRange = [];
    for (let i = 1; i <= this.pages; i++) {
      if (i === 1 || i === this.pages || (i <= this.pageNumber + this.pageRangeDelta && i >= this.pageNumber - this.pageRangeDelta)) {
        this.pagesRange.push(i);
      }
    }
  }
}

